/* Mega menu image tiles - Advantage Empire (Oct 2026)
   Images in a dropdown load the first time that dropdown is opened (hover, focus or click),
   so the homepage doesn't download ~35 menu images up front. */
(function () {
  function load(root) {
    if (!root || root.dataset.mtLoaded) return;
    root.dataset.mtLoaded = '1';
    [].forEach.call(root.querySelectorAll('img[data-src]'), function (img) {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    });
  }
  function init() {
    [].forEach.call(document.querySelectorAll('.main-nav > li > details'), function (det) {
      var blocks = det.querySelectorAll('[data-mega-tiles], [data-mobile-tiles]');
      if (!blocks.length) return;
      var go = function () { [].forEach.call(blocks, load); };
      var s = det.querySelector('summary');
      s.addEventListener('mouseenter', go, { once: true });
      s.addEventListener('focusin', go, { once: true });
      s.addEventListener('touchstart', go, { once: true, passive: true });
      det.addEventListener('toggle', function () { if (det.open) go(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
